export const FETCH_DOCUMENTS_BY_ID_REQUEST = 'FETCH_DOCUMENTS_BY_ID_REQUEST';
export const FETCH_DOCUMENTS_BY_ID_SUCCESS = 'FETCH_DOCUMENTS_BY_ID_SUCCESS';
export const FETCH_DOCUMENTS_BY_ID_FAILED = 'FETCH_DOCUMENTS_BY_ID_FAILED';

export const FETCH_UPDATE_DOCUMENT_REQUEST = 'FETCH_UPDATE_DOCUMENT_REQUEST';
export const FETCH_UPDATE_DOCUMENT_SUCCESS = 'FETCH_UPDATE_DOCUMENT_SUCCESS';
export const FETCH_UPDATE_DOCUMENT_FAILED = 'FETCH_UPDATE_DOCUMENT_FAILED';

export const FETCH_UPLOAD_DOCUMENT_REQUEST = 'FETCH_UPLOAD_DOCUMENT_REQUEST';
export const FETCH_UPLOAD_DOCUMENT_SUCCESS = 'FETCH_UPLOAD_DOCUMENT_SUCCESS';
export const FETCH_UPLOAD_DOCUMENT_FAILED = 'FETCH_UPLOAD_DOCUMENT_FAILED';

export const FETCH_DOWNLOAD_DOCUMENT_REQUEST = 'FETCH_DOWNLOAD_DOCUMENT_REQUEST';
export const FETCH_DOWNLOAD_DOCUMENT_SUCCESS = 'FETCH_DOWNLOAD_DOCUMENT_SUCCESS';
export const FETCH_DOWNLOAD_DOCUMENT_FAILED = 'FETCH_DOWNLOAD_DOCUMENT_FAILED';
export const RESET_FILE = 'RESET_FILE';
export const RESET_CURRENT_DEFAULT_VERSION = 'RESET_CURRENT_DEFAULT_VERSION';

// V2

export const CREATE_VERSION_REQUEST = 'CREATE_VERSION_REQUEST';
export const CREATE_VERSION_SUCCESS = 'CREATE_VERSION_SUCCESS';
export const CREATE_VERSION_FAILURE = 'CREATE_VERSION_FAILURE';

export const FETCH_VERSION_REQUEST = 'FETCH_VERSION_REQUEST';
export const FETCH_VERSION_SUCCESS = 'FETCH_VERSION_SUCCESS';
export const FETCH_VERSION_FAILURE = 'FETCH_VERSION_FAILURE';

export const UPDATE_VERSION_REQUEST = 'UPDATE_VERSION_REQUEST';
export const UPDATE_VERSION_SUCCESS = 'UPDATE_VERSION_SUCCESS';
export const UPDATE_VERSION_FAILURE = 'UPDATE_VERSION_FAILURE';

export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST';
export const CREATE_DOCUMENT_SUCCESS = 'CREATE_DOCUMENT_SUCCESS';
export const CREATE_DOCUMENT_FAILURE = 'CREATE_DOCUMENT_FAILURE';

export const FETCH_DOCUMENTS_REQUEST = 'FETCH_DOCUMENTS_REQUEST';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE';

export const FETCH_DOCUMENT_REQUEST = 'FETCH_DOCUMENT_REQUEST';
export const FETCH_DOCUMENT_SUCCESS = 'FETCH_DOCUMENT_SUCCESS';
export const FETCH_DOCUMENT_FAILURE = 'FETCH_DOCUMENT_FAILURE';

export const UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST';
export const UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS';
export const UPDATE_DOCUMENT_FAILURE = 'UPDATE_DOCUMENT_FAILURE';

export const DELETE_VERSIONS_FILE_REQUEST = 'DELETE_VERSIONS_FILE_REQUEST';
export const DELETE_VERSIONS_FILE_SUCCESS = 'DELETE_VERSIONS_FILE_SUCCESS';
export const DELETE_VERSIONS_FILE_FAILURE = 'DELETE_VERSIONS_FILE_FAILURE';

export const FETCH_DELETE_VERSION_REQUEST = 'FETCH_DELETE_VERSION_REQUEST';
export const FETCH_DELETE_VERSION_SUCCESS = 'FETCH_DELETE_VERSION_SUCCESS';
export const FETCH_DELETE_VERSION_FAILED = 'FETCH_DELETE_VERSION_FAILED';

export const FETCH_VERSION_BY_DOCUMENT_REQUEST = 'FETCH_VERSION_BY_DOCUMENT_REQUEST';
export const FETCH_VERSION_BY_DOCUMENT_SUCCESS = 'FETCH_VERSION_BY_DOCUMENT_SUCCESS';
export const FETCH_VERSION_BY_DOCUMENT_FAILED = 'FETCH_VERSION_BY_DOCUMENT_FAILED';

export const UPLOAD_VERSIONS_FILE_REQUEST = 'UPLOAD_VERSIONS_FILE_REQUEST';
export const UPLOAD_VERSIONS_FILE_SUCCESS = 'UPLOAD_VERSIONS_FILE_SUCCESS';
export const UPLOAD_VERSIONS_FILE_FAILURE = 'UPLOAD_VERSIONS_FILE_FAILURE';

export const DELETE_VERSION_REQUEST = 'DELETE_VERSION_REQUEST';
export const DELETE_VERSION_SUCCESS = 'DELETE_VERSION_SUCCESS';
export const DELETE_VERSION_FAILURE = 'DELETE_VERSION_FAILURE';

export const DELETE_DOCUMENT_REQUEST = 'DELETE_DOCUMENT_REQUEST';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';
export const DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE';

export const UPLOAD_VERIONS_FILE_REQUEST = 'UPLOAD_VERIONS_FILE_REQUEST';
export const UPLOAD_VERIONS_FILE_SUCCESS = 'UPLOAD_VERIONS_FILE_SUCCESS';
export const UPLOAD_VERIONS_FILE_FAILURE = 'UPLOAD_VERIONS_FILE_FAILURE';

export const FETCH_VERSION_BY_ID_REQUEST = 'FETCH_VERSION_BY_ID_REQUEST';
export const FETCH_VERSION_BY_ID_SUCCESS = 'FETCH_VERSION_BY_ID_SUCCESS';
export const FETCH_VERSION_BY_ID_FAILURE = 'FETCH_VERSION_BY_ID_FAILURE';

export const FETCH_DOCUMENT_TYPES_REQUEST = 'FETCH_DOCUMENT_TYPES_REQUEST';
export const FETCH_DOCUMENT_TYPES_SUCCESS = 'FETCH_DOCUMENT_TYPES_SUCCESS';
export const FETCH_DOCUMENT_TYPES_FAILURE = 'FETCH_DOCUMENT_TYPES_FAILURE';

export const UPDATE_DOCUMENT_TYPE_REQUEST = 'UPDATE_DOCUMENT_TYPE_REQUEST';
export const UPDATE_DOCUMENT_TYPE_SUCCESS = 'UPDATE_DOCUMENT_TYPE_SUCCESS';
export const UPDATE_DOCUMENT_TYPE_FAILURE = 'UPDATE_DOCUMENT_TYPE_FAILURE';
